import { render, staticRenderFns } from "./MLivesLive.vue?vue&type=template&id=deba1d82"
import script from "./MLivesLive.vue?vue&type=script&lang=js"
export * from "./MLivesLive.vue?vue&type=script&lang=js"
import style0 from "./MLivesLive.vue?vue&type=style&index=0&id=deba1d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports